import React from 'react';
import styled from 'styled-components';

interface IErrorMessage {
  message: string;
}

const ErrorMessageLayout = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.colors.Crimson};
  margin-top: 0.25rem;
`;
const ErrorMessage: React.FC<IErrorMessage> = ({ message }) => {
  return <ErrorMessageLayout>{message}</ErrorMessageLayout>;
};

export { ErrorMessage };
